import React, { Suspense } from 'react';
import { useGlobalConfigContext } from 'core/contexts/GlobalConfig';
import { GlobalConfig } from 'core/interfaces';
import { PaymentSettings, PersonalSettings } from 'core/models';
import { Loading } from '@fides/fides-react-components';
import { Redirect, Route, Switch } from 'react-router-dom';

const FromTemplate = React.lazy(() => import('../../components/pages/FromTemplate'));

export const FromTemplateRouter = () => {
  const globalConfig: GlobalConfig = useGlobalConfigContext();
  const personalSettings: PersonalSettings = globalConfig.user?.settings?.personal;
  const paymentSettings: PaymentSettings = personalSettings?.payment;

  const hasAccessToCreateOrderByTemplate =
    paymentSettings?.templates &&
    (globalConfig.accessHelper.hasAuthorityName('PAYMENT_CREATE_ANY_GRANT') ||
      globalConfig.accessHelper.hasAuthorityName('PAYMENT_CREATE_FROM_TEMPLATE_GRANT'));

  return (
    <Switch>
      <Route path='/from-templates' exact>
        <Suspense fallback={<Loading />}>
          {hasAccessToCreateOrderByTemplate ? <FromTemplate /> : <Redirect to='/page-not-found' />}
        </Suspense>
      </Route>
    </Switch>
  );
};
